if (!customElements.get('bf-help-page')) {
  customElements.define('bf-help-page', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const content = this.querySelector('[data-help-content]');
      if (!content) return;

      if (this.dataset.enhanced !== 'true') {
        const headings = [...content.querySelectorAll('h2')];
        const prefix = this.dataset.anchorPrefix || 'BfHelp';
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `${prefix}-abschnitt-${index + 1}`;
            while (document.getElementById(id)) id += '-a';
            heading.id = id;
          }
          heading.tabIndex = -1;
        });

        if (this.dataset.accordion === 'true') this.enhanceQuestions(content);

        const lists = this.querySelectorAll('[data-help-toc-list]');
        if (headings.length > 1 && lists.length > 0) {
          lists.forEach((list) => {
            const entries = headings.map((heading) => {
              const item = document.createElement('li');
              const link = document.createElement('a');
              link.href = `#${encodeURIComponent(heading.id)}`;
              link.textContent = heading.textContent.trim();
              item.append(link);
              return item;
            });
            list.replaceChildren(...entries);
          });
          this.querySelectorAll('[data-help-toc]').forEach((toc) => { toc.hidden = false; });
          this.classList.add('bf-help-page--has-toc');
        }
        this.dataset.enhanced = 'true';
      }

      const signal = this.abortController.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-help-toc] a');
        if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        this.revealHeading(link.hash, true);
      }, { signal });
      window.addEventListener('hashchange', () => this.revealHeading(window.location.hash, true), { signal });
      this.revealHeading(window.location.hash, false);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.abortController?.abort();
    }

    enhanceQuestions(content) {
      [...content.children].filter((node) => node.tagName === 'H2').forEach((heading, index) => {
        const answer = document.createElement('div');
        answer.className = 'bf-help-faq__answer';
        let next = heading.nextSibling;
        while (next && !(next.nodeType === Node.ELEMENT_NODE && next.tagName === 'H2')) {
          const current = next;
          next = next.nextSibling;
          answer.append(current);
        }
        const details = document.createElement('details');
        details.className = 'bf-help-faq';
        const summary = document.createElement('summary');
        const indicator = document.createElement('span');
        indicator.className = 'bf-help-faq__indicator';
        indicator.setAttribute('aria-hidden', 'true');
        heading.before(details);
        summary.append(heading, indicator);
        details.append(summary, answer);
        details.open = index === 0 || Boolean(answer.querySelector('mark, .content-draft-note'));
      });
    }

    revealHeading(hash, focus) {
      if (!hash || hash === '#') return;
      let id;
      try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
      const heading = document.getElementById(id);
      if (!heading || !this.querySelector('[data-help-content]')?.contains(heading)) return;
      const details = heading.closest('details');
      if (details) details.open = true;
      if (focus) heading.focus({ preventScroll: true });
      heading.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
  });
}
